import { c as _c } from "react/compiler-runtime";
import type { CMSSeoContentData } from "@website/website-ui/services/seo-contents/cms-types";
import { Faq } from "../faq";
import { InboundLinks } from "../inbound-links";
import { SeoContent } from "../seo-content";
export const SeoComponents = t0 => {
  const $ = _c(13);
  const {
    seoData,
    linksTitle
  } = t0;
  let t1;
  if ($[0] !== seoData) {
    t1 = seoData || {};
    $[0] = seoData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    seoContent,
    FAQ,
    links
  } = t1;
  let t2;
  if ($[2] !== seoContent) {
    t2 = Boolean(seoContent) && <SeoContent html={seoContent} />;
    $[2] = seoContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== FAQ) {
    t3 = Boolean(FAQ?.length) && <Faq list={FAQ} title={"\u067E\u0627\u0633\u062E \u0628\u0647 \u0628\u0631\u062E\u06CC \u0633\u0648\u0627\u0644\u0627\u062A"} />;
    $[4] = FAQ;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== links || $[7] !== linksTitle) {
    t4 = Boolean(links?.length) && <InboundLinks linksData={links} title={linksTitle ?? "\u0633\u0641\u0631 \u0628\u0639\u062F\u06CC\u062A \u0631\u0648 \u0627\u0632 \u0627\u0644\u0627\u0646 \u0628\u0631\u0646\u0627\u0645\u0647 \u0631\u06CC\u0632\u06CC \u06A9\u0646"} />;
    $[6] = links;
    $[7] = linksTitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};